import React, { useState, useEffect } from "react"; 
import { Splide, SplideSlide } from "@splidejs/react-splide";
import "@splidejs/react-splide/css";
import "./InfiniteScroll.css";
import Apple from '../../Assets/apple.svg';
import Amazon from '../../Assets/amazon.png';
import Facebook from '../../Assets/Facebook.png';
import Tata from '../../Assets/tata.png';
import Microsoft from '../../Assets/microsoft.jpg';
import Nvidia from '../../Assets/nvidia.png';
import Samsung from '../../Assets/samsung.png';
import Google from '../../Assets/google.png'; 


const companyIcons = [
  { Icon: Amazon, name: "Amazon" },
  { Icon: Google, name: "Google" },
  { Icon: Apple, name: "Apple" },
  { Icon: Facebook, name: "Facebook" },
  { Icon: Microsoft, name: "Microsoft" },
  { Icon: Tata, name: "Tata" },
  { Icon: Nvidia, name: "Nvidia" },
  { Icon: Samsung, name: "Samsung" }, 
];

const InfiniteScroll = () => {

  const getVisibleSlidesCount = (width) => {
    if (width > 1356) return 7;
    if (width > 1086) return 6;
    if (width >= 768) return 5;
    if (width >= 480) return 4;
    return 3;
  };
 

  
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [visibleSlidesCount, setVisibleSlidesCount] = useState(getVisibleSlidesCount(windowWidth));
 
  useEffect(() => {
    const handleResize = () => {
      const newWidth = window.innerWidth;
      setWindowWidth(newWidth);
      setVisibleSlidesCount(getVisibleSlidesCount(newWidth));
     };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  return (
    <div className="infinite-scroll-container">
      <Splide
        options={{
          type: "loop",
          perPage: visibleSlidesCount,
          drag: true,
          gap: "0px",
          autoplay: true,
          interval: 2400,
          arrows: false,
          pagination: false,
          speed: 500,
          focus: "center",
        }}
      >
        {companyIcons.concat(companyIcons).map(({ Icon, name }, index) => (
          <SplideSlide key={index}>
            <div className="infinite-icon-item">
              <img src={Icon} alt={name} /> 
            </div>
          </SplideSlide>
        ))}
      </Splide>
    </div>
  );
};

export default InfiniteScroll;
